import styled from 'styled-components';

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 12px;
  margin: -6px 8px 0;
`;

export const DropdownArrow = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const NewDropdown = styled.div<{
  height: string;
  width: string;
  error: boolean;
}>`
  select {
    background: transparent;
    font-size: 14px;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    height: ${(props) => props.height};
    width: 100%;
    appearance: none;
    border: 0;
    padding-left: 10px;
    padding-right: 33px;
    appearance: 'none';
    width: '100%';
    &:invalid {
      color: ${({ theme }) => theme.palette.text.disabled};
    }
  }

  overflow: hidden;
  height: ${(props) => props.height};
  width: ${(props) =>
    props.width ? props.width : 'auto; display: inline-block'};
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: ${(props) => (props.error ? '1px' : '0')} solid
    ${(props) =>
      props.error
        ? props.theme.palette.error.main
        : props.theme.palette.divider};
  cursor: pointer;
  position: relative;
  min-width: 100px;
  margin: 5px 0;
  box-sizing: border-box;
  box-shadow: ${({ theme }) => theme.shadows[3]};

  &:focus-within {
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;
